import store from '../store'

export default async (to, from, next) => {

  if (!store.getters['auth/check']) {

    next({name: 'Login'})
  } else if (!store.getters['resource/availableResources'].length > 0) {
    next({name: 'Setup Step 1'})
  }
  else {
    next()
  }

}
